import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Youtube, Linkedin } from "lucide-react";
import { BRAND, NAV_LINKS } from "../mock";

const serviceLinks = [
  { label: "Dry Cleaning", href: "/services/dry-cleaning" },
  { label: "Organic Dry Cleaning", href: "/services/organic-dry-cleaning" },
  { label: "Laundry / Wash", href: "/services/laundry" },
  { label: "Shoe Cleaning", href: "/services/shoe-cleaning" },
  { label: "Bag Cleaning", href: "/services/bag-cleaning" },
  { label: "Sofa Cleaning", href: "/services/sofa-cleaning" },
];

const companyLinks = [
  { label: "About Us", href: "/" },
  { label: "Prepaid Plans", href: "/plans" },
  { label: "Blog", href: "/blog" },
  { label: "Contact Us", href: "/contact" },
  { label: "Franchise", href: "/contact" },
];

const Footer = () => {
  return (
    <footer className="bg-navy text-white pt-14 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="bg-white rounded-lg inline-block p-2 mb-4">
              <img src={BRAND.logo} alt={BRAND.name} className="h-14 w-auto object-contain" />
            </div>
            <p className="text-white/70 text-sm leading-relaxed mb-4">
              India's trusted on-demand laundry & dry cleaning service. Doorstep pickup, expert care and delivery in 48 hours.
            </p>
            <div className="flex gap-3">
              {[Facebook, Instagram, Twitter, Youtube, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-orange-brand flex items-center justify-center transition-colors">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Services</h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.href} className="text-white/70 hover:text-orange-brand text-sm transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Company</h4>
            <ul className="space-y-2.5">
              {companyLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.href} className="text-white/70 hover:text-orange-brand text-sm transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Get in Touch</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-3"><Phone size={17} className="mt-0.5 text-orange-brand shrink-0" /><a href={`tel:${BRAND.phone}`} className="hover:text-orange-brand">{BRAND.phoneDisplay}</a></li>
              <li className="flex items-start gap-3"><Mail size={17} className="mt-0.5 text-orange-brand shrink-0" /><a href={`mailto:${BRAND.email}`} className="hover:text-orange-brand">{BRAND.email}</a></li>
              <li className="flex items-start gap-3"><MapPin size={17} className="mt-0.5 text-orange-brand shrink-0" /><span>Serving 92+ cities across India</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-white/60">
          <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <div className="flex gap-5">
            <a href="#" className="hover:text-orange-brand">Privacy Policy</a>
            <a href="#" className="hover:text-orange-brand">Terms of Service</a>
            <a href="#" className="hover:text-orange-brand">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
